import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="app-footer"
            className="mt-auto border-t border-[var(--ns-border)] bg-[var(--ns-bg)]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center gap-2 text-[var(--ns-text2)]">
                    <span className="w-6 h-6 rounded-lg flex items-center justify-center" style={{ background: 'var(--ns-navy)' }}>
                        <MapPin size={12} className="text-white" />
                    </span>
                    <span className="text-sm">© {year} NextStop</span>
                </div>
                <nav className="flex items-center gap-5 text-sm">
                    <Link
                        to="/premium"
                        data-testid="footer-premium-link"
                        className="text-[var(--ns-text2)] hover:text-[var(--ns-clay)] transition"
                    >
                        Premium
                    </Link>
                    <Link
                        to="/privacy-policy"
                        data-testid="footer-privacy-link"
                        className="text-[var(--ns-text2)] hover:text-[var(--ns-clay)] transition"
                    >
                        Privacy
                    </Link>
                    <Link
                        to="/terms"
                        data-testid="footer-terms-link"
                        className="text-[var(--ns-text2)] hover:text-[var(--ns-clay)] transition"
                    >
                        Terms
                    </Link>
                </nav>
            </div>
        </footer>
    );
}
